import cn from 'classnames';
import withSuspense from 'es/core/hocs/withSuspense';
import { useI18n } from 'es/core/hooks/useI18n';
import React, { ReactNode } from 'react';
import { Button, ButtonProps as BlueprintButtonProps, Intent } from '@blueprintjs/core';
import './Buttons.scss';

// This is the props type as declared by Blueprint
type ButtonProps = Omit<React.ButtonHTMLAttributes<HTMLButtonElement> & BlueprintButtonProps, 'icon'>;

export interface IActionButtonProps {
    text?: ReactNode;
}

export const ActionButton = React.forwardRef<HTMLButtonElement, IActionButtonProps & ButtonProps>(
    (props: IActionButtonProps & ButtonProps, ref) => {
        const { text, intent, ...rest } = props;

        const buttonIntent = intent ?? Intent.NONE;
        const className = cn('action-button', props.className);

        return (
            <Button {...rest} className={className} intent={buttonIntent} ref={ref}>
                {text}
            </Button>
        );
    }
);

const ActionButtonHoC = (i18nKey: string) => {
    const Wrapper = (props: IActionButtonProps & ButtonProps) => {
        const { l10n } = useI18n('app', 'action');

        const buttonText = props.text ? props.text : l10n(i18nKey);

        return <ActionButton {...props} text={buttonText} />;
    };

    return withSuspense(Wrapper);
};

export const AddButton = ActionButtonHoC('add');
export const ViewButton = ActionButtonHoC('view');
export const CancelButton = ActionButtonHoC('cancel');
export const CloseButton = ActionButtonHoC('close');
export const DeleteButton = ActionButtonHoC('delete');
export const EditButton = ActionButtonHoC('edit');
export const ResetButton = ActionButtonHoC('reset');
export const RunButton = ActionButtonHoC('run');
export const SaveButton = ActionButtonHoC('save');
export const OkayButton = ActionButtonHoC('ok');
